export default "__VITE_ASSET__CTjBVZqw__"